// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M4EP6","label":"styles_label__2LvWt"};